/**
 * Fetcher tracking — hit eksternal courier API via BE.
 *
 * Cache lebih panjang (5 menit) karena upstream courier API mahal.
 * BE side juga sebaiknya cache.
 */
import http from "@/config/http";

/* Generic tracking by AWB. BE memilih courier berdasarkan awb prefix/format. */
export async function fetchTracking(awb) {
  const { data } = await http.get(`/api/v1/tracking/tracking/${awb}`);
  return data;
}

/* Nice Express specific (cabang khusus pada FE) */
export async function fetchTrackingNiceExpress(awb) {
  const { data } = await http.get(`/api/v1/tracking/nice-express/${awb}`);
  return data;
}
